"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _commentsContext = _interopRequireDefault(require("../../../contexts/commentsContext")),
    _CommentsTab = _interopRequireDefault(require("../components/CommentsTab"));

function CommentsTab(props) {
  var groupCommentsFn = props.groupCommentsFn,
      isVideoReview = props.isVideoReview,
      selectedGroupId = props.selectedGroupId,
      selectedCommentId = props.selectedCommentId,
      onSelectComment = props.onSelectComment,
      getCommentTitle = props.getCommentTitle,
      onAddComment = props.onAddComment,
      addCommentDisabled = props.addCommentDisabled,
      tabTitle = props.tabTitle,
      showAddCommentButton = props.showAddCommentButton,
      selectedClipId = props.selectedClipId;
  return _react["default"].createElement(_commentsContext["default"].Consumer, null, function (_ref) {
    var _ref$state = _ref.state,
        comments = _ref$state.comments,
        commentModalId = _ref$state.commentModalId,
        isReadOnly = _ref$state.isReadOnly,
        canResolveComment = _ref$state.canResolveComment,
        closeModalOrigin = _ref$state.closeModalOrigin,
        _ref$actions = _ref.actions,
        showCommentModal = _ref$actions.showCommentModal,
        closePopover = _ref$actions.closePopover,
        getOrderedComments = _ref$actions.getOrderedComments,
        tabComments = isVideoReview ? getOrderedComments(selectedClipId) : Array.from(comments.values());
    return _react["default"].createElement(_CommentsTab["default"], {
      comments: tabComments,
      groupCommentsFn: groupCommentsFn,
      selectedGroupId: selectedGroupId,
      onSelectComment: onSelectComment,
      selectedCommentId: selectedCommentId || commentModalId,
      getCommentTitle: getCommentTitle,
      canResolveComment: canResolveComment,
      onAddComment: onAddComment,
      addCommentDisabled: addCommentDisabled,
      closePopover: closePopover,
      showCommentModal: showCommentModal,
      commentModalId: commentModalId,
      tabTitle: tabTitle,
      isReadOnly: isReadOnly,
      showAddCommentButton: showAddCommentButton,
      closeModalOrigin: closeModalOrigin
    });
  });
}

var _default = CommentsTab;
exports["default"] = _default;